/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './select-similar-piece.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/material';
import * as i3 from '../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i4 from '@angular/flex-layout/flexbox/api/class';
import * as i5 from '@angular/flex-layout/media-query/media-monitor';
import * as i6 from '@angular/common';
import * as i7 from '@angular/flex-layout/flexbox/api/layout';
import * as i8 from '../../../../../app/shared/dialogs/select-similar-piece/select-similar-piece.component';
import * as i9 from '../../../../../app/agatextscreens/inventory/inventory.service';
const styles_SelectSimilarPieceComponent:any[] = [i0.styles];
export const RenderType_SelectSimilarPieceComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SelectSimilarPieceComponent,data:{}});
function View_SelectSimilarPieceComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'p',[['md-line',
      '']],[[2,'mat-line',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(16384,[[1,4]],0,i2.MdLine,([] as any[]),(null as any),
      (null as any)),(_l()(),i1.ɵted((null as any),[' ','/','/',' ']))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_1:any = (<any>_v.parent).context.$implicit.collection_name;
        const currVal_2:any = (<any>_v.parent).context.$implicit.design_name;
        const currVal_3:any = (<any>_v.parent).context.$implicit.name;
        _ck(_v,2,0,currVal_1,currVal_2,currVal_3);
      });
}
function View_SelectSimilarPieceComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'p',[['md-line',
      '']],[[2,'mat-line',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(16384,[[1,4]],0,i2.MdLine,([] as any[]),(null as any),
      (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['class',
      'md-18'],['role','img'],['style','display: inline-flex; vertical-align: middle; color:darkgray']],
      [[2,'mat-icon',(null as any)]],(null as any),(null as any),i3.View_MdIcon_0,
      i3.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,
      i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i2.MdIcon,[i1.ElementRef,i1.Renderer2,i2.MdIconRegistry],
          (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i4.ClassDirective,
          [i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,
          ['warning'])),(_l()(),i1.ɵted((null as any),[' This piece has defect ']))],
      (_ck,_v) => {
        _ck(_v,4,0);
        const currVal_2:any = 'md-18';
        _ck(_v,5,0,currVal_2);
      },(_ck,_v) => {
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_1:any = true;
        _ck(_v,2,0,currVal_1);
      });
}
function View_SelectSimilarPieceComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'p',[['md-line',
      '']],[[2,'mat-line',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(16384,[[1,4]],0,i2.MdLine,([] as any[]),(null as any),
      (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['class',
      'md-18'],['role','img'],['style','display: inline-flex; vertical-align: middle; color:darkgray']],
      [[2,'mat-icon',(null as any)]],(null as any),(null as any),i3.View_MdIcon_0,
      i3.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,
      i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i2.MdIcon,[i1.ElementRef,i1.Renderer2,i2.MdIconRegistry],
          (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i4.ClassDirective,
          [i5.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,
          ['bookmark'])),(_l()(),i1.ɵted((null as any),[' This piece is reserved ']))],
      (_ck,_v) => {
        _ck(_v,4,0);
        const currVal_2:any = 'md-18';
        _ck(_v,5,0,currVal_2);
      },(_ck,_v) => {
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_1:any = true;
        _ck(_v,2,0,currVal_1);
      });
}
function View_SelectSimilarPieceComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'p',[['md-line',
      '']],[[2,'mat-line',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(16384,[[1,4]],0,i2.MdLine,([] as any[]),(null as any),
      (null as any)),(_l()(),i1.ɵted((null as any),[' Also part of the order ']))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
      });
}
function View_SelectSimilarPieceComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),26,'md-list-item',
      [['role','listitem'],['style','cursor:pointer']],[[2,'mat-list-item',(null as any)]],
      [[(null as any),'click'],[(null as any),'focus'],[(null as any),'blur']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('focus' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2)._handleFocus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('click' === en)) {
          const pd_2:any = ((<any>_co.choose(_v.context.$implicit)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i3.View_MdListItem_0,i3.RenderType_MdListItem)),i1.ɵdid(16384,(null as any),
      0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(1097728,(null as any),2,i2.MdListItem,[i1.Renderer2,i1.ElementRef,
      [2,i2.MdList],[2,i2.MdNavListCssMatStyler]],(null as any),(null as any)),i1.ɵqud(603979776,
      1,{_lines:1}),i1.ɵqud(335544320,2,{_hasAvatar:0}),(_l()(),i1.ɵted(2,['\n      '])),
      (_l()(),i1.ɵeld(0,(null as any),1,2,'h4',[['md-line','']],[[4,'color',(null as any)],
          [2,'mat-line',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,[[1,4]],0,i2.MdLine,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n        ',' ( ','m ) - ',
          '\n      '])),(_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵeld(0,(null as any),
          1,3,'p',[['md-line','']],[[2,'mat-line',(null as any)]],(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(16384,[[1,4]],0,i2.MdLine,([] as any[]),
          (null as any),(null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'span',[['style','height: 60%; color:darkgray']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['[Location: ',']'])),(_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),1,1,(null as any),View_SelectSimilarPieceComponent_2)),i1.ɵdid(16384,
          (null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),1,1,(null as any),View_SelectSimilarPieceComponent_3)),i1.ɵdid(16384,
          (null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),1,1,(null as any),View_SelectSimilarPieceComponent_4)),i1.ɵdid(16384,
          (null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(2,['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),1,1,(null as any),View_SelectSimilarPieceComponent_5)),i1.ɵdid(16384,
          (null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(2,['\n    ']))],(_ck,_v) => {
    const currVal_8:boolean = !_v.context.$implicit.disabled;
    _ck(_v,16,0,currVal_8);
    const currVal_9:any = _v.context.$implicit.defect;
    _ck(_v,19,0,currVal_9);
    const currVal_10:any = _v.context.$implicit.reserved;
    _ck(_v,22,0,currVal_10);
    const currVal_11:any = _v.context.$implicit.disabled;
    _ck(_v,25,0,currVal_11);
  },(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = ((_v.context.$implicit.disabled || _v.context.$implicit.defect)? 'darkgray': '');
    const currVal_2:any = true;
    _ck(_v,6,0,currVal_1,currVal_2);
    const currVal_3:any = _v.context.$implicit.piece_number;
    const currVal_4:any = _v.context.$implicit.length;
    const currVal_5:any = _v.context.$implicit.grade_code;
    _ck(_v,8,0,currVal_3,currVal_4,currVal_5);
    const currVal_6:any = true;
    _ck(_v,10,0,currVal_6);
    const currVal_7:any = _v.context.$implicit.location_name;
    _ck(_v,13,0,currVal_7);
  });
}
export function View_SelectSimilarPieceComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),14,'div',[['fxLayout',
      'column']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i7.LayoutDirective,[i5.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h4',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['Select new Piece'])),(_l()(),i1.ɵted((null as any),
          ['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'md-list',[['role',
          'list'],['style','height: 400px; overflow: scroll']],[[2,'mat-list',(null as any)]],
          (null as any),(null as any),i3.View_MdList_0,i3.RenderType_MdList)),i1.ɵdid(16384,
          (null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i2.MdList,([] as any[]),(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i2.MdListCssMatStyler,([] as any[]),(null as any),(null as any)),(_l()(),
          i1.ɵted(0,['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),
          View_SelectSimilarPieceComponent_1)),i1.ɵdid(802816,(null as any),0,i6.NgForOf,
          [i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},
          (null as any)),(_l()(),i1.ɵted(0,['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i8.SelectSimilarPieceComponent = _v.component;
    const currVal_0:any = 'column';
    _ck(_v,1,0,currVal_0);
    const currVal_2:any = _co.products;
    _ck(_v,12,0,currVal_2);
  },(_ck,_v) => {
    const currVal_1:any = true;
    _ck(_v,6,0,currVal_1);
  });
}
export function View_SelectSimilarPieceComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-select-similar-piece',
      ([] as any[]),(null as any),(null as any),(null as any),View_SelectSimilarPieceComponent_0,
      RenderType_SelectSimilarPieceComponent)),i1.ɵdid(114688,(null as any),0,i8.SelectSimilarPieceComponent,
      [i9.InventoryService,i2.MdDialogRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SelectSimilarPieceComponentNgFactory:i1.ComponentFactory<i8.SelectSimilarPieceComponent> = i1.ɵccf('app-select-similar-piece',
    i8.SelectSimilarPieceComponent,View_SelectSimilarPieceComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/shared/dialogs/select-similar-piece/select-similar-piece.component.ngfactory.ts